'use client';

import React__default from 'react';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import { Radio } from './Radio.js';
import { useTranslate } from '../../../Contexts/translator/index.js';
import { Title } from '../Title.js';
import { useOnBoarding } from '../../context/index.js';

var ChooseResume = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), resumeType = _a.resumeType, setResumeType = _a.setResumeType;
    return (React__default.createElement(Col, null,
        React__default.createElement(Row, { gutter: [24, 0] },
            React__default.createElement(Col, null,
                React__default.createElement(Title, { title: t('Do you have a CV yet?'), subTitle: t("We're using this info to make your experience unique.") })),
            React__default.createElement(Col, { xs: 24 },
                React__default.createElement(Row, { gutter: 12 },
                    React__default.createElement(Col, { xs: 24, md: 12 },
                        React__default.createElement(Radio, { title: t('I already have a CV'), description: t('Allocating 5 - 8 minutes for your information can pave the way to your dream job or the right company for you.'), image: 'https://staging-images.vietnamworks.com/onboarding/already-have-cv.png', value: resumeType === 'attachCV', onChange: function () { return setResumeType('attachCV'); }, name: 'attachCV' })),
                    React__default.createElement(Col, { xs: 24, md: 12 },
                        React__default.createElement(Radio, { title: t("No profile yet? Let's build your VietnamWorks profile together."), description: t('Allocating 15 - 20 minutes to provide your details, ensuring you have a professional CV and easy profile management down the road.'), image: 'https://staging-images.vietnamworks.com/onboarding/create-vnw-profile.png', value: resumeType === 'vnwProfile', onChange: function () { return setResumeType('vnwProfile'); }, name: 'profile' })))))));
};

export { ChooseResume as default };
//# sourceMappingURL=index.js.map
